import { LANGUAGE_LIST_STORAGE_KEY } from '../constants/translationConfig';

/**
 * Keeps the last language list received from the backend, so the next page load can show the
 * right languages (and the right text direction) immediately, before the request finishes.
 */
export const readCachedLanguages = () => {
    try {
        const parsed = JSON.parse(window.localStorage.getItem(LANGUAGE_LIST_STORAGE_KEY) || 'null');
        return Array.isArray(parsed) && parsed.length > 0 ? parsed : null;
    } catch {
        return null;
    }
};

export const writeCachedLanguages = (remoteLanguages) => {
    try {
        window.localStorage.setItem(LANGUAGE_LIST_STORAGE_KEY, JSON.stringify(remoteLanguages));
    } catch {
        /* storage blocked or full: the list is simply fetched again next time */
    }
};
